export interface InsightTriggerConfig {
  type: string;
  contextMessage: string;
  delayMs: number;
  localStorageKey: string;
}

export const INSIGHT_TRIGGERS: Record<string, InsightTriggerConfig> = {
  insight_low_stock: {
    type: 'insight_low_stock',
    contextMessage:
      'Looks like you\'re keeping a close eye on your inventory. If Assisty is helping you stay on top of stock levels, would you share your experience?',
    delayMs: 3000,
    localStorageKey: 'insight_low_stock_triggered',
  },
  insight_repeat_visit: {
    type: 'insight_repeat_visit',
    contextMessage:
      'You\'ve been using Assisty regularly this week. If it\'s been helpful, a quick review would mean a lot to us.',
    delayMs: 2000,
    localStorageKey: 'insight_repeat_visit_triggered',
  },
  insight_business_overview: {
    type: 'insight_business_overview',
    contextMessage:
      'Now that your data is loaded, how are you finding Assisty? A review helps other merchants like you discover us.',
    delayMs: 3000,
    localStorageKey: 'insight_business_overview_triggered',
  },
  insight_deep_engagement: {
    type: 'insight_deep_engagement',
    contextMessage:
      'It looks like you found some useful insights. If Assisty is helping your business, would you mind leaving a quick review?',
    delayMs: 0,
    localStorageKey: 'insight_deep_engagement_triggered',
  },
};

export function getTriggerConfig(type: string): InsightTriggerConfig | undefined {
  return INSIGHT_TRIGGERS[type];
}
